/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Private Flags API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RuleView,
    RuleViewFromJSON,
    RuleViewFromJSONTyped,
    RuleViewToJSON,
    UrlList,
    UrlListFromJSON,
    UrlListFromJSONTyped,
    UrlListToJSON,
} from './';

/**
 * view
 * @export
 * @interface RulesView
 */
export interface RulesView {
    /**
     * 
     * @type {Array<RuleView>}
     * @memberof RulesView
     */
    items: Array<RuleView>;
    /**
     * Number of rules on the current page.
     * @type {number}
     * @memberof RulesView
     */
    count: number;
    /**
     * Number of the current page. 1-index based.
     * @type {number}
     * @memberof RulesView
     */
    page: number;
    /**
     * Total number of rules.
     * @type {number}
     * @memberof RulesView
     */
    total_count: number;
    /**
     * Total number of pages for this series.
     * @type {number}
     * @memberof RulesView
     */
    total_pages: number;
    /**
     * Link to self
     * @type {string}
     * @memberof RulesView
     */
    url: string;
    /**
     * Link to first page of rules in a series.
     * @type {string}
     * @memberof RulesView
     */
    first_url: string;
    /**
     * Link to the last page of rules in a series.
     * @type {string}
     * @memberof RulesView
     */
    last_url: string;
    /**
     * List of links to next pages of rules in a series.   The first element in the array is the exact next page after the current record, etc. 
     * @type {UrlList}
     * @memberof RulesView
     */
    next_url?: UrlList;
    /**
     * List of links to previous pages of rules in a series.  The first element in the array is the exact previous page before the current record, etc. 
     * @type {UrlList}
     * @memberof RulesView
     */
    prev_url?: UrlList;
}

export function RulesViewFromJSON(json: any): RulesView {
    return RulesViewFromJSONTyped(json, false);
}

export function RulesViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): RulesView {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(RuleViewFromJSON)),
        'count': json['count'],
        'page': json['page'],
        'total_count': json['total_count'],
        'total_pages': json['total_pages'],
        'url': json['url'],
        'first_url': json['first_url'],
        'last_url': json['last_url'],
        'next_url': !exists(json, 'next_url') ? undefined : UrlListFromJSON(json['next_url']),
        'prev_url': !exists(json, 'prev_url') ? undefined : UrlListFromJSON(json['prev_url']),
    };
}

export function RulesViewToJSON(value?: RulesView | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(RuleViewToJSON)),
        'count': value.count,
        'page': value.page,
        'total_count': value.total_count,
        'total_pages': value.total_pages,
        'url': value.url,
        'first_url': value.first_url,
        'last_url': value.last_url,
        'next_url': UrlListToJSON(value.next_url),
        'prev_url': UrlListToJSON(value.prev_url),
    };
}


